import en from './locales/en.json';
import de from './locales/de.json';

export const cardsLocales = {
  en: { cards: en },
  de: { cards: de },
};

export * from './store/cards.store';
export { default as CardsPage } from './CardsPage.vue';
export { default as YourCards } from './YourCards.vue';
export * from './cards.routes';
